import { HIDE_APP_LOADER, SHOW_APP_LOADER, CURRENT_SELECTED_TAB } from './types';

export const initialState = {
  displayAppLoader: true,
  currentSelectedTab: null
};

export const appLoaderReducer = (
  state: { displayAppLoader: boolean; currentSelectedTab: string | null } = initialState,
  action: any
) => {
  switch (action.type) {
    case SHOW_APP_LOADER:
    case HIDE_APP_LOADER:
      return {
        ...state,
        displayAppLoader: action.displayAppLoader
      };
    case CURRENT_SELECTED_TAB:
      return {
        ...state,
        currentSelectedTab: action.currentSelectedTab
      };
    default:
      return state;
  }
};
